module.exports = __webpack_public_path__ + "img/food-img-2.9ece9679.png";